var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVattenfallLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 109,
    viewBox: "0 0 708 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_76)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M653.779 0C623.844 0 599.577 24.267 599.577 54.202H707.981C707.981 24.267 683.714 0 653.779 0Z",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M653.779 108.404C623.844 108.404 599.577 84.1371 599.577 54.2021H707.981C707.981 84.1371 683.714 108.404 653.779 108.404Z",
    fill: "#2071B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.097 24.9033H115.775V38.1583H133.696V86.7603H149.896V38.1583H166.097V24.9033Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.741 24.9033V38.1583H187.942V86.7603H204.142V38.1583H222.063V24.9033H171.741Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.361 86.7603V24.9033H329.897V61.9183L302.33 24.9033H286.866V86.7603H302.33V50.1923L329.897 86.7603H345.361Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.917 86.7603H246.117H275.656V73.5053H246.117V61.3313H271.154V48.0763H246.117V38.1583H275.656V24.9033H229.917V86.7603Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.687 86.7603H373.888V61.7233H400.039V48.4673H373.888V38.1583H404.899V24.9033H357.687V86.7603Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0365 24.9033L33.4195 68.3923H33.2805L15.6645 24.9033H0.000488281L25.3765 86.7603H41.3245L66.7005 24.9033H51.0365Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.917 86.7603H568.648V73.0283H540.117V24.9033H523.917V86.7603Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.196 86.7603H516.928V73.0283H488.396V24.9033H472.196V86.7603Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.692 63.1243L433.156 41.9973H433.263L441.758 63.1223L424.692 63.1243ZM451.264 86.7603H466.927L441.142 24.9033H440.94H425.478H425.277L399.491 86.7603H415.155L419.597 75.7143H446.822L451.264 86.7603Z",
    fill: "#4E4B48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4556 63.1243L89.9196 41.9973H90.0266L98.5216 63.1223L81.4556 63.1243ZM108.028 86.7603H123.691L97.9056 24.9033H97.7036H82.2416H82.0406L56.2546 86.7603H71.9186L76.3606 75.7143H103.586L108.028 86.7603Z",
    fill: "#4E4B48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 708,
    height: 109,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVattenfallLogo);
export default __webpack_public_path__ + "static/media/vattenfall-logo.4c0f90ed1b56a9a8567afe7d5110ee22.svg";
export { ForwardRef as ReactComponent };